// @ts-nocheck
import React, { FC, useState, useEffect } from 'react';
import { whichAuth as getAuth } from '../../getAuth';
import { handleErrors } from '../../utils/handleErrors';
import { addCircleOutline } from 'ionicons/icons';
import { REST_API_URL } from '../../constants/global';
import {
  IonSearchbar,
  IonList,
  IonItem,
  IonRow,
  IonCol,
  IonIcon,
} from '@ionic/react';
import './ProviderSearch.css'
import { ProviderSearchProps } from "./ProviderSearch.model";
import AlertModal from "../AlertModal";

const ProviderSearch: FC<ProviderSearchProps> = ({ onSelect, selectedService, clearSelectedService }) => {
  
  const [providers, setProviders] = useState([]);
  const [showProviderSearchResults, setShowProviderSearchResults] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [searchService, setSearchService] = useState<string>('');
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const [modalMessage, setModalMessage] = useState<string>('');
  
  const searchProvidersByName = term => {
    if(!term) {
      setShowProviderSearchResults(false);
    } else {
      getAuth().currentUser.getIdToken().then(token =>
        fetch(REST_API_URL + '/providers/search/findByNameContainingIgnoreCaseOrderByName?name=' + term, {headers: {'Authorization': 'Bearer ' + token}})
          .then(handleErrors)
          .then(response => {
            setShowProviderSearchResults(!!term);
            setProviders(response._embedded.providers);
          })
          .catch(() => {
            setIsOpenModal(true)
            setModalMessage('Failed to search for providers with name ' + term)
          })
      );
    }
  }
  
  const searchProvidersByService = service => {
    if(!service) {
      setShowProviderSearchResults(false);
    } else {
      getAuth().currentUser.getIdToken().then(token =>
        fetch(REST_API_URL + '/providers/search/findByServiceOrderByName?service=' + service, {headers: {'Authorization': 'Bearer ' + token}})
          .then(handleErrors)
          .then(response => {
            setShowProviderSearchResults(true);
            setProviders(response._embedded.providers);
          })
          .catch(() => {
            setIsOpenModal(true)
            setModalMessage('Failed to search for ' + service + ' providers')
          })
          .finally(clearSelectedService)
      );
    }
  }

  selectedService && selectedService !== searchService && setSearchService(selectedService);
  
  useEffect(() => searchProvidersByName(searchTerm), [searchTerm]);
  useEffect(() => searchProvidersByService(searchService), [searchService]);
  
  return (
      <div style={{zIndex:'2', width:'100%', height: 'auto'}}>
      { <IonSearchbar placeholder="Telstra, Origin, Medibank..."
          onIonChange={term => setSearchTerm(term.detail.value)}
          onFocus={() => searchProvidersByName(searchTerm)} 
          onIonClear={() => setShowProviderSearchResults(false)} /> }
          
      { showProviderSearchResults &&
        <IonList className="provider-search-list">
          { providers.map( provider => 
            <IonItem key={provider.id} onClick={() => {
              setShowProviderSearchResults(false);
              setProviders([]);
              onSelect(provider)
            }}>
              <IonRow className="provider-search-item" >
                <IonCol className="provider-search-col provider-search-logo"><img src={provider.logo.replace(/upload/,'upload/h_20').replace(/.svg$/, '.png')} alt="logo"/></IonCol>
                <IonCol className="provider-search-col">{provider.name} <small>({provider.service})</small></IonCol>
                <IonCol className="provider-search-col" size="auto"><IonIcon icon={addCircleOutline} color="primary" className="provider-search-plus-icon" /></IonCol>
              </IonRow>
            </IonItem>
          )}
          { providers?.length === 0 &&
            <IonItem>No providers found. If you want us to add your provider, please send an email to &nbsp; 
            <a href="mailto:hello@billsmoov.com.au" target="_blank" className="provider-search-no-results-contact">hello@billsmoov.com.au</a></IonItem>
          }
        </IonList>
      }
        <AlertModal
          isOpen={isOpenModal}
          title={modalMessage}
          onClosed={() => setIsOpenModal(false)}
        />
      </div>
  );
}

export default ProviderSearch;
